import { render, staticRenderFns } from "./WritingReportCardComponent.vue?vue&type=template&id=2a055a5d&scoped=true&"
import script from "./WritingReportCardComponent.vue?vue&type=script&lang=js&"
export * from "./WritingReportCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./WritingReportCardComponent.vue?vue&type=style&index=0&id=2a055a5d&prod&lang=css&"
import style1 from "./WritingReportCardComponent.vue?vue&type=style&index=1&id=2a055a5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a055a5d",
  null
  
)

export default component.exports